import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// Sincroniza un valor de estado con un search param de la URL — reutilizable
// para cualquier filtro/pestaña/vista/selección que deba sobrevivir a un
// "volver" o al botón Atrás del navegador (proceso seleccionado, vista
// Visual/Tabla/Kanban, pestaña activa de una ficha, búsqueda, etc.).
// Usa `replace` siempre: cambiar un filtro o de pestaña es una actualización
// de la vista actual, no una navegación nueva — no debe apilar entradas de
// historial por cada tecla escrita o cada clic en un chip de filtro.
export function useEstadoEnUrl(clave: string, valorPorDefecto = "") {
  const [searchParams, setSearchParams] = useSearchParams();
  const valor = searchParams.get(clave) ?? valorPorDefecto;

  const establecer = useCallback(
    (nuevo: string) => {
      setSearchParams(
        (previos) => {
          const siguientes = new URLSearchParams(previos);
          if (!nuevo || nuevo === valorPorDefecto) siguientes.delete(clave);
          else siguientes.set(clave, nuevo);
          return siguientes;
        },
        { replace: true },
      );
    },
    [clave, valorPorDefecto, setSearchParams],
  );

  return [valor, establecer] as const;
}
